var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFailed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.7666C12.94 4.7666 4 13.7066 4 24.7666C4 35.8266 12.94 44.7666 24 44.7666C35.06 44.7666 44 35.8266 44 24.7666C44 13.7066 35.06 4.7666 24 4.7666ZM34 31.9466L31.18 34.7666L24 27.5866L16.82 34.7666L14 31.9466L21.18 24.7666L14 17.5866L16.82 14.7666L24 21.9466L31.18 14.7666L34 17.5866L26.82 24.7666L34 31.9466Z",
    fill: "#F01111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Failed.71cae8399d0e44ecc15aa41dd99cf088.svg";